import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getTopListBokningAntalByAfid,setofUpdatedashboardBokaTV} from 'actions'
import {isEmpty,isUndefined,isNull} from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress';
import {Grid} from '@material-ui/core'
import { withStyles } from '@material-ui/styles';
import compose from 'recompose/compose';
import { Progress } from 'reactstrap';
import Icon from '../../img/crown.svg';
import { ReactComponent as IconDev } from '../../img/crown.svg';
import { sv } from "date-fns/locale";
import {format}  from 'date-fns';
import Skeleton from '@material-ui/lab/Skeleton';
import IntlMessages from 'util/IntlMessages';

const styles = props => ({
    colorPrimary: {
      backgroundColor: '#12585E',
    },
    barColorPrimary: {
      backgroundColor: '#44D1C2',
    },
    MainProgress: {
        backgroundColor: '#12585E !important',
        borderRadius:"30px",
        height: '10px !important',
        
    },
    scroll: {
        marginRight: '16px',
        marginLeft: '16px',
        paddingTop: '18px',
        paddingRight: '6px',
        '&::-webkit-scrollbar': {
            width: '5px'
        },
        
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
        },
        
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#12484B',
            outline: '1px solid transparent'
        }
    }
  });

function mapStateToProps({auth,DashBoard,accountsData}) {
    const { authUser} = auth;
    const { updatedashboardBokaTY} = accountsData
    const { TopListBokAntal,DashboardBokaFilterOption} = DashBoard;
    return {
        authUser,TopListBokAntal,DashboardBokaFilterOption,updatedashboardBokaTY
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getTopListBokningAntalByAfid: (Afid,userid,FilterOption) => dispatch(getTopListBokningAntalByAfid(Afid,userid,FilterOption)),
        setofUpdatedashboardBokaTV: () => dispatch(setofUpdatedashboardBokaTV()),
        dispatch
    };
}
const ColorCode=[
    '#DAA520',
    '#C0C0C0',
    '#b08d57'
]
class TopList extends Component {
    state={
        TopListBokAntal:[],
        DashboardBokaFilterOption:parseInt(this.props.Kontor) === 0?[]:[{Meta:"Kontor",Value:this.props.Kontor}],
        done: false
    }
    intervalID = null
    componentDidMount=()=>{
        const Afid = this.props.Afid;
        
        this.props.getTopListBokningAntalByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
            this.initiateInterval()
            this.setState({done: true})
         })          
    }
    initiateInterval () {
        clearInterval(this.intervalID);
        this.intervalID = null 
        this.intervalID = setInterval(
            () => {
                if(this.state.done === true){ 
                    this.setState({done: false,})
                    const Afid = this.props.Afid;
                    this.props.getTopListBokningAntalByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                        this.initiateInterval()
                        this.setState({done: true})
                     })
                }
            },
            180000
        );
      }
    componentWillUnmount() {
        clearInterval(this.intervalID);
        this.intervalID = null
    }

    componentDidUpdate=()=>{
        const Afid = this.props.Afid;
        if(parseInt(this.props.updatedashboardBokaTY) === 1){
            this.props.getTopListBokningAntalByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) 
            this.props.setofUpdatedashboardBokaTV()
        }
        if(this.props.DashboardBokaFilterOption !== this.state.DashboardBokaFilterOption && !isEmpty(this.props.DashboardBokaFilterOption))
           {
            this.setState({ done:false })
              
               this.props.getTopListBokningAntalByAfid(Afid,undefined,this.state.DashboardBokaFilterOption).then(() => { 
                this.initiateInterval()
                this.setState({done: true})
             }) /**/
               this.setState({
                DashboardBokaFilterOption:this.props.DashboardBokaFilterOption 
               }) 
           }
        }
        formatNumber=(number)=>{
            return `${(number).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}`
        }

    render() {
        console.log('test565445',this.props.TopListBokAntal)
        const { classes } = this.props;
        return (
            <div style={{ width: '100%', height: '100%', color: 'white' }}>
            <div className="text-center mb-2">
                <h2 style={{ paddingTop: '12px',margin: '0',fontSize: this.props.isFrom === 1 ? '20px' : '24px'  }}><b><IntlMessages id="DashBoard.TopList"/></b></h2>
                {/* <p style={{fontSize: this.props.isFrom === 1 ? 14 : "18px"}}><IntlMessages id="Month.Current"/></p> */}
                <p style={{ fontSize: this.props.isFrom === 1 ? 14 : '18px', textTransform: "capitalize" }}>{format(new Date(), 'MMMM', { locale: sv })}</p>
            </div>
            <div className={classes.scroll} style={{overflowY: "auto",maxHeight: this.props.height > 1 ? this.props.height : 200,height: "100%",overflowX:"hidden", marginTop: '-15px'}}>
            {
                 this.state.done === false?  
                 <>
                 <div className="row mx-1">
                     <div className="col-12 row mx-1">
                         <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>
                     <div className="col-12 row mx-1">
                         <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>
                     <div className="col-12 row mx-1">
                         <Skeleton variant="rectangular" height={40} width={'100%'} style={{margin:'3px auto',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
                     </div>
                 </div>
                 </>
                 :
                    isEmpty(this.props.TopListBokAntal)?
                    <>
                    <Grid container spacing={1} className={"mb-1"} alignItems="center">
                        <Grid item xs={2} style={{fontSize:"1.2rem", fontWeight:"500"}}>
                            Topp 1
                        </Grid>
                        <Grid item xs={8} >
                            <LinearProgress classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}
                            variant={"determinate"} style={{height:".5rem", borderRadius: '20px'}}  value={"60"}/>
                        </Grid>
                        <Grid item xs={2} style={{textAlign:"right",fontSize:"1.3rem", fontWeight:"300"}}>
                        <span style={{fontSize:"1.1rem", fontWeight:"300"}}>
                            0
                            </span>
                            <span
                            style={{fontSize:".7rem", fontWeight:"300"}}
                            >St</span>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1}  className={"mb-1"} alignItems="center">
                        <Grid item xs={2} style={{fontSize:"1.2rem", fontWeight:"500"}}>
                            Topp 2
                        </Grid>
                        <Grid item xs={8} >
                            <LinearProgress   classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}
                            variant={"determinate"} style={{height:".5rem", borderRadius: '20px'}} value={"50"}/>
                        </Grid>
                        <Grid item xs={2} style={{textAlign:"right"}}>
                            <span style={{fontSize:"1.1rem", fontWeight:"300"}}>
                            0
                            </span>
                            <span
                            style={{fontSize:".7rem", fontWeight:"300"}}
                            >St</span>
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} className={"mb-1"} alignItems="center">
                        <Grid item xs={2} style={{fontSize:"1.2rem", fontWeight:"500"}}>
                            Topp 3
                        </Grid>
                        <Grid item xs={8} >
                            <LinearProgress  classes={{colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary}}
                            variant={"determinate"} style={{height:".5rem", borderRadius: '20px'}}   value={"30"}/>
                        </Grid>
                        <Grid item xs={2} style={{textAlign:"right",fontSize:"1.3rem", fontWeight:"300"}}>
                        <span style={{fontSize:"1.1rem", fontWeight:"300"}}>
                            0
                            </span>
                            <span
                            style={{fontSize:".7rem", fontWeight:"300"}}
                            >St</span>
                        </Grid>
                    </Grid>
                    </>
                    :
                    this.props.TopListBokAntal.map((object,index) =>
                        <Grid container spacing={5} alignItems="center">
                            {/* <Grid item xs={2}>
                                {index+1}.
                                <div></div>
                            </Grid> */}
                            <Grid item xs={3} style={{fontSize:"1.2rem", fontWeight:"300", paddingRight: '0px'}}>
                                <span>{index+1}. </span>
                                {`${object.FirstName} ${isEmpty(object.LastName.substring(0,1))?"":object.LastName.substring(0,1)}`}    
                            </Grid>
                            <Grid item xs={7} style={{ position: 'relative' }}>
                                <Progress multi className={classes.MainProgress}> 
                                    <Progress bar 
                                    // animated 
                                    style={{ backgroundColor: parseInt(object.total)>=parseInt(object.Budget) ? '#77ED9C' : '#44D1C2'}}
                                    // color={parseInt(object.total)>=parseInt(object.Budget)?"success":"defaultNoty2"}
                                    value={parseInt(object.total)} max={parseInt(object.total)>=parseInt(object.Budget)?parseInt(object.total):parseInt(object.Budget)} 
                                    >
                                    <div
                                        style={{ 
                                            marginLeft: '-17.5px', 
                                            borderRadius: '50%', 
                                            height: '35px', 
                                            width: '35px', 
                                            border: '2px solid #fff', 
                                            backgroundColor: isEmpty(object.ProfilePicUrl) ? '#075A5F' : '',
                                            position: 'absolute', 
                                            left: `${parseInt((object.total/object.Budget)*100) > 95 ? 95 : parseInt((object.total/object.Budget)*100)}%`,
                                            // left: `${parseInt(object.total) < 100 ? parseInt(object.total) : 100}%`,
                                            top:8,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundImage: 'url('+object.ProfilePicUrl+')',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center'
                                        }}
                                    >
                                        {
                                            index === 0 ?
                                            (
                                                process.env.NODE_ENV === 'development' ?
                                                <IconDev style={{ height: '15px', width: 'auto', position: 'absolute', top:'-15px', left: '-10px', transform: 'rotate(-0.1turn)' }}></IconDev>
                                                :
                                                <Icon style={{ height: '15px', width: 'auto', position: 'absolute', top:'-15px', left: '-10px', transform: 'rotate(-0.1turn)' }}></Icon>
                                            )
                                           : ''
                                        }

                                       <p style={{color: '#fff'}}>
                                            {
                                                isEmpty(object.ProfilePicUrl) ?(
                                                `${object.FirstName.substring(0,1)}${isEmpty(object.LastName.substring(0,1))?"":object.LastName.substring(0,1)}`) 
                                                :''
                                            }
                                        </p>
                                    </div>
                                    </Progress>
                                    {/* <Progress bar 
                                    // animated 
                                    style={{ backgroundColor: parseInt(object.total)>=parseInt(object.Budget) ? '#77ED9C' : '#44D1C2'}}
                                    // color={parseInt(object.total)>=parseInt(object.Budget)?"success":"defaultNoty2"}
                                    value={parseInt(object.total)} max={parseInt(object.total)>=parseInt(object.Budget)?parseInt(object.total):parseInt(object.Budget)} 
                                    /> */}

                                </Progress>
                            </Grid>
                            <Grid item xs={2} style={{ textAlign:"right", paddingLeft: '0px' }}>
                              {
                                parseInt(this.props.Flags.DashboardBokaFormat) === 0 ?
                                <>
                                  <span style={{fontSize:"1.1rem", fontWeight:"500"}}>
                                  {this.formatNumber(object.total)}
                                  </span>
                                  <span
                                  style={{fontSize:".8rem", fontWeight:"300"}}>St/{object.Budget}
                                  </span>
                                </>
                                : 
                                <>
                                  <span style={{fontSize:"1.1rem", fontWeight:"500"}}>
                                  {parseInt((object.total/object.Budget)*100)}%
                                  </span>
                                </>
                              }
                            </Grid>

                        </Grid>
                        // <Grid container spacing={1} className={"mb-1"}>
                        //     <Grid item xs={6} style={{fontSize:"1.2rem", fontWeight:"300"}}>
                        //         {index+1}. {`${object.FirstName} ${isEmpty(object.LastName)?"":object.LastName}`}    
                        //     </Grid>
                        //     <Grid item xs={6} style={{textAlign:"right"}}>
                        //         <span style={{fontSize:"1.1rem", fontWeight:"300"}}>
                        //         {this.formatNumber(object.total)}
                        //         </span>
                        //         <span
                        //         style={{fontSize:".7rem", fontWeight:"300"}}>St/{object.Budget}
                        //         </span>
                        //     </Grid>
                        //     <Grid item xs={12} className="m-1">
                        //         <Progress multi className={classes.MainProgress}> 
                        //             <Progress bar 
                        //             // animated 
                        //             style={{ backgroundColor: parseInt(object.total)>=parseInt(object.Budget) ? '#77ED9C' : '#44D1C2'}}
                        //             // color={parseInt(object.total)>=parseInt(object.Budget)?"success":"defaultNoty2"}
                        //             value={parseInt(object.total)} max={parseInt(object.total)>=parseInt(object.Budget)?parseInt(object.total):parseInt(object.Budget)} 
                        //             />
                        //         </Progress>

                        //     </Grid>
                        // </Grid>
                    )
            }
            </div>
        </div>
        );
    }
}
export default compose(
    connect(
        mapStateToProps,mapDispatchToProps
    ),
    withStyles(styles)
    )(TopList);

